export default "__VITE_ASSET__enKaVSlr__"